/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import {
  Button,
  Form,
  Grid,
  Icon,
  Input,
  Modal,
  Pagination,
  Popup,
  Radio,
  Segment,
  Image
} from 'semantic-ui-react';
import _ from 'lodash';
import api from '../../../api';
import ResultadosCorpus from './ResultadosCorpus';
import CorpusLoader from './CorpusLoader';
import questImg from '../../../assets/img/questImg.png';

const PAGE_SIZE = 10;

function countWords(str) {
  return str.trim().split(/\s+/).length;
}

const paginationStyle = {
  marginTop: '15px',
  backgroundColor: 'aliceblue'
};

const buttonStyle = {
  marginLeft: '8px'
};

const inputStyle = {
  width: '250px'
};

class CorpusSearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      radioValue: 'forma',
      modalOpen: false,
      activePage: 1,
      data: {
        value: '',
        ejemplos: [],
        totalCount: 0
      }
    };
  }

  handleClose = () => this.setState({ modalOpen: false });

  handleRadioChange = (e, { value }) => {
    this.setState({ radioValue: value });
  };

  handleInputChange = e =>
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
        sinResultados: false
      }
    });

  handleFocus = () =>
    this.setState({
      data: {
        ...this.state.data,
        ejemplos: [],
        sinResultados: false,
        value: ''
      }
    });

  searchByForma = (limit, offset) => {
    // const errors = this.validate(this.state.data);
    // this.setState({ errors });

    // if (Object.keys(errors).length === 0) {
    api.corpus
      .getByForma(this.state.data.value.trim(), limit, offset)
      .then(frases => this.generateCorpusResult(frases));
    // }
  };

  searchByFormasCombinadas = (limit, offset) => {
    if (countWords(this.state.data.value.trim()) < 2) {
      this.setState({ modalOpen: true, loading: false });
      return;
    }
    // const errors = this.validate(this.state.data);
    // this.setState({ errors });

    // if (Object.keys(errors).length === 0) {
    api.corpus
      .getByFormasCombinadas(this.state.data.value.trim(), limit, offset)
      .then(frases => this.generateCorpusResult(frases));
    // }
  };

  searchByLemma = (limit, offset) => {
    // const errors = this.validate(this.state.data);
    // this.setState({ errors });

    // if (Object.keys(errors).length === 0) {
    api.corpus
      .getByLemma(this.state.data.value.trim(), limit, offset)
      .then(frases => this.generateCorpusResult(frases));
    // }
  };

  generateCorpusResult = frases => {
    const ejemplos = this.getEjemplosFromFrases(frases);
    const totalCount = frases.length !== 0 ? frases[0].count : 0;
    this.setState({
      data: {
        ...this.state.data,
        ejemplos,
        totalCount,
        sinResultados: ejemplos.length === 0
      },
      loading: false
    });
  };

  getEjemplosFromFrases = frases =>
    frases.map(frase => this.getEjemplosFromFrase(frase));

  getEjemplosFromFrase = frase => {
    const ejemplo = {
      fraseAnterior: {
        id: parseInt(frase.id, 10) - 1,
        texto: frase.fraseanterior
      },
      fraseActual: {
        id: parseInt(frase.id, 10),
        texto: frase.frase,
        highlight: frase.forma
      },
      fraseSiguiente: {
        id: parseInt(frase.id, 10) + 1,
        texto: frase.frasesiguiente
      }
    };
    return ejemplo;
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage, loading: true });
    const offset = activePage * PAGE_SIZE - PAGE_SIZE;
    this.search(PAGE_SIZE, offset);
  };

  handleButtonClick = () => {
    if (!this.state.data.value) {
      return;
    }
    this.setState({
      data: { ...this.state.data, ejemplos: [] },
      loading: true,
      activePage: 1
    });
    this.search();
  };

  search = () => this.search(0, PAGE_SIZE);

  search = (limit, offset) => {
    switch (this.state.radioValue) {
      case 'forma':
        this.searchByForma(limit, offset);
        break;
      case 'lema':
        this.searchByLemma(limit, offset);
        break;
      case 'formasCombinadas':
        this.searchByFormasCombinadas(limit, offset);
        break;
      default:
    }
  };

  render() {
    const { radioValue, data } = this.state;
    return (
      <div>
        <Modal
          header="Formas combinadas"
          content="Se debe indicar más de una palabra para este tipo de búsqueda"
          open={this.state.modalOpen}
          onClose={this.handleClose}
          actions={[{ key: 'done', content: 'Aceptar', positive: true }]}
        />

        <Form>
          <Grid>
            <Grid.Column width="five">
              <Form.Field>
                <Popup
                  trigger={
                    <Radio
                      label="Forma"
                      name="radioGroup"
                      value="forma"
                      checked={radioValue === 'forma'}
                      onChange={this.handleRadioChange}
                    />
                  }
                  position="right center"
                >
                  <Popup.Content>
                    p.ej.
                    <b>
                      <i> investigamos</i>
                    </b>
                    ,
                    <b>
                      <i> resultados </i>
                    </b>
                    o
                    <b>
                      <i> exhaustivas</i>
                    </b>
                  </Popup.Content>
                </Popup>
              </Form.Field>
              <Form.Field>
                <Popup
                  trigger={
                    <Radio
                      label="Lema"
                      name="radioGroup"
                      value="lema"
                      checked={radioValue === 'lema'}
                      onChange={this.handleRadioChange}
                    />
                  }
                  position="right center"
                >
                  <Popup.Content>
                    p.ej.
                    <b>
                      <i> investigar</i>
                    </b>
                    ,
                    <b>
                      <i> resultado </i>
                    </b>
                    o
                    <b>
                      <i> exhaustivo</i>
                    </b>
                  </Popup.Content>
                </Popup>
              </Form.Field>
              <Form.Field>
                <Popup
                  trigger={
                    <Radio
                      label="Formas combinadas"
                      name="radioGroup"
                      value="formasCombinadas"
                      checked={radioValue === 'formasCombinadas'}
                      onChange={this.handleRadioChange}
                    />
                  }
                  position="right center"
                >
                  <Popup.Content>
                    p.ej.
                    <b>
                      <i> desde esta perspectiva </i>
                    </b>
                    o
                    <b>
                      <i> los resultados</i>
                    </b>
                  </Popup.Content>
                </Popup>
              </Form.Field>
            </Grid.Column>
            <Grid.Column width="10" verticalAlign="middle">
              <Input
                focus
                placeholder={`Búsqueda por ${_.lowerCase(radioValue)}...`}
                onChange={this.handleInputChange}
                name="value"
                value={data.value}
                onFocus={this.handleFocus}
                style={inputStyle}
              />
              <Button onClick={this.handleButtonClick} style={buttonStyle}>
                Buscar
              </Button>
              <Image 
                src={questImg} 
                as='a' 
                size='medium' 
                href='https://www.youtube.com/watch?v=rLTbrnCVApc' 
                target='blank_' 
                avatar
                className="mystyle6 mystyle8"
              />
            </Grid.Column>

            <Grid.Column width="six" verticalAlign="middle">
              {this.state.data.ejemplos.length ? (
                <Segment secondary>
                  {this.state.data.totalCount === 1 ? (
                    <div>
                      Se ha encontrado <b>{this.state.data.totalCount} </b>
                      resultado
                    </div>
                  ) : (
                    <div>
                      Se han encontrado <b>{this.state.data.totalCount} </b>
                      resultados
                    </div>
                  )}
                </Segment>
              ) : null}
            </Grid.Column>
          </Grid>
          
        </Form>

        {this.state.loading ? (
          <CorpusLoader />
        ) : (
          <div>
            <ResultadosCorpus
              data={this.state.data}
              radioValue={this.state.radioValue}
            />
            {this.state.data.ejemplos.length ? (
              <Pagination
                defaultActivePage={1}
                activePage={this.state.activePage}
                onPageChange={this.handlePaginationChange}
                totalPages={Math.ceil(this.state.data.totalCount / PAGE_SIZE)}
                ellipsisItem={{
                  content: <Icon name="ellipsis horizontal" />,
                  icon: true
                }}
                firstItem={{
                  content: <Icon name="angle double left" />,
                  icon: true
                }}
                lastItem={{
                  content: <Icon name="angle double right" />,
                  icon: true
                }}
                prevItem={{ content: <Icon name="angle left" />, icon: true }}
                nextItem={{ content: <Icon name="angle right" />, icon: true }}
                style={paginationStyle}
              />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default CorpusSearchPanel;
